<template>
  <div
    v-if="step === 1"
    v-motion
    :initial="{ opacity: 0, y: 30 }"
    :enter="{ opacity: 1, y: 0, transition: { delay: 300, duration: 500 } }"
    :leave="{ opacity: 0, y: -30, transition: { duration: 500 } }"
    class="placeholder row center"
  >
    <i class="fa-solid fa-rocket"></i>
    <span>Starting Up</span>
  </div>

  <div
    v-if="step === 2"
    v-motion
    :initial="{ opacity: 0, y: 30 }"
    :enter="{ opacity: 1, y: 0, transition: { delay: 300, duration: 500 } }"
    :leave="{ opacity: 0, y: -30, transition: { duration: 500 } }"
    class="placeholder row center"
  >
    <i class="fa-solid fa-glasses"></i>
    <span>Searching</span>
  </div>

  <div
    v-if="step === 3"
    v-motion
    :initial="{ opacity: 0, y: 30 }"
    :enter="{ opacity: 1, y: 0, transition: { delay: 300, duration: 500 } }"
    :leave="{ opacity: 0, y: -30, transition: { duration: 500 } }"
    class="placeholder row center"
  >
    <i class="fa-solid fa-feather"></i>
    <span>Handcrafting</span>
  </div>

  <div
    v-if="step === 4"
    v-motion
    :initial="{ opacity: 0, y: 30 }"
    :enter="{ opacity: 1, y: 0, transition: { delay: 300, duration: 500 } }"
    :leave="{ opacity: 0, y: -30, transition: { duration: 500 } }"
    class="placeholder row center"
  >
    <i class="fa-solid fa-gift"></i>
    <span>Wrapping up</span>
  </div>

  <div
    v-if="step === 5"
    v-motion
    :initial="{ opacity: 0, y: 30 }"
    :enter="{ opacity: 1, y: 0, transition: { delay: 300, duration: 500 } }"
    :leave="{ opacity: 0, y: -30, transition: { duration: 500 } }"
    class="placeholder row center"
  >
    <i class="fa-solid fa-flag-checkered"></i>
    <span>Finishing</span>
  </div>

  <div
    v-if="step === 6"
    v-motion
    :initial="{ opacity: 0, y: 30 }"
    :enter="{ opacity: 1, y: 0, transition: { delay: 300, duration: 500 } }"
    :leave="{ opacity: 0, y: -30, transition: { duration: 500 } }"
    class="placeholder row center"
  >
    <i class="fa-solid fa-truck"></i>
    <span>Delivering</span>
  </div>

  <div
    v-if="step === 7"
    v-motion
    :initial="{ opacity: 0, y: 30 }"
    :enter="{ opacity: 1, y: 0, transition: { delay: 300, duration: 500 } }"
    :leave="{ opacity: 0, y: -30, transition: { duration: 500 } }"
    class="placeholder row center"
  >
    <i class="fa-solid fa-traffic-light"></i>
    <span>Last stop</span>
  </div>

  <div
    v-if="step === 8"
    v-motion
    :initial="{ opacity: 0, y: 30 }"
    :enter="{ opacity: 1, y: 0, transition: { delay: 300, duration: 500 } }"
    :leave="{ opacity: 0, y: -30, transition: { duration: 500 } }"
    class="placeholder row center"
  >
    <i class="fa-solid fa-bell"></i>
    <span>Here we are</span>
  </div>
</template>

<script>
export default {
  name: 'WaitingSteps',
  props: {
    step: { type: Number, default: 0 },
  },
}
</script>

<style lang="scss" scoped>
.placeholder {
  margin-left: 15px;
  width: 150px;

  i {
    margin-right: 7px;
  }
}
</style>
